import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../components/FormikControl/FormikControl';
import { Add, Check, CheckCircle, Edit, FindReplace, Pending, PendingActions } from '@mui/icons-material';
import { useAlert } from '../../../../context/AlertContext';
import notesServices from '../notesServices';
import moment from 'moment';



function NotesForm({data,notesGroupList,callBack}) {
    const {AppAlert} = useAlert();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        title:"",
        linkUrl:"",
        details:"",
        group:"",
        
    }

    const updateData = ()=>{
        let autoFill = {
            id:data._id,
            linkUrl:data.linkUrl,
            title:data.title,
            details:data.details,
            group:data.group,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        title:Yup.string().required("Required"),
        //details:Yup.string().required("Required"),
        group:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        setSavingStatus(true);

        console.log(values);
        
        notesServices.save(values).then(res=>{
            //console.log(res.msg);
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack()
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
        
    }

    const remove = () =>{
        if(data?.id){
            notesServices.remove(data.id).then(res=>{
                AppAlert("Archived");
                setDialogStatus(false);
                callBack()
            })
        }
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-sm my-2 mx-2 btn-outline-warning bg-dark" onClick={addNew} ><Add/> Add New</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="View / Update">
                    <span type="button" className="border-bottom border-primary text-white px-0 py-1 ps-1 w-100" style={{fontSize:12}} onClick={updateData} >
                        {data.title}
                        {data.linkUrl !== undefined && data.linkUrl !== "" && <a href={data.linkUrl} target='_blank' className='btn btn-primary mb-2 p-0 btn-sm px-1 ms-2'>Reference Link</a> }
                    </span>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogContent>
                                            <div className="row">
                                                <div className="col-md-12 border border-primary">
                                                    <div className="row">
                                                        {notesGroupList && 
                                                            <FormikControl control="autoselect" formik={formik} 
                                                                label="Group" name="group"  
                                                                labelName="title" valueName={"_id"}
                                                                options={notesGroupList} multiple={false} 
                                                                className="col-md-12 p-2"
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-12 border border-primary">
                                                    <div className="row p-2">
                                                        <FormikControl control="input" formik={formik} type="text" 
                                                            label="Reference Link If any" name="linkUrl" 
                                                            className="col-md-12 col-xs-12 mb-3" 
                                                        />
                                                    </div>
                                                    {formik.values.linkUrl !== "" &&
                                                        <a href={formik.values.linkUrl} target='_blank' className='btn btn-primary mb-2'>Reference Link</a>
                                                    }
                                                </div>
                                                <div className="col-md-12 border border-primary">
                                                    <div className="row p-2">
                                                        <FormikControl control="input" formik={formik} type="text" 
                                                            label="Title" name="title" 
                                                            className="col-md-12 col-xs-12 mb-3" 
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 border border-primary">
                                                    <div className="row p-2">
                                                        <FormikControl control="input" formik={formik} type="text" multiline={true} rows={10}
                                                            label="Details" name="details" 
                                                            className="col-md-12 col-xs-12 mb-3 mb-5" 
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        {data?.id !== undefined && <button className="btn btn-outline-primary float-end me-5" type="button" onClick={remove}>Archive</button> }
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values) */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}
    

export default NotesForm